import React from 'react'
import ComingSoon from '../components/ComingSoon'

const HolidayBasket = () => {
  return (
    <ComingSoon />
  )
}

export default HolidayBasket